export const getDataSourceIconClass = (ds) => (
    !ds ? "fad fs-circle-question" :
    ds.type === "flow" ? "fad fa-random" :
    ds.structured ? "fad fa-database" :
    ds.fileType === "json" ? "fad fa-brackets-curly" :
    ds.fileType === "js" ? "fab fa-js" :
    "fad fa-code"
);


export const getReportIcon = (r) => 
    r.type === "spreadsheet" ? <i className={`fas fa-table`} style={{ color: "#207446" }}/> :
    r.type === "slides" ? <i className={`fas fa-presentation-screen`} style={{ color: "#e55a0e" }}/> :
    <i className={'fas fa-book'} style={{ color: "#42b4ff" }}/>

export const getReportIconClass = (r) =>
    r.type === "spreadsheet" ? "fa-sharp fa-solid fa-file-spreadsheet" :
    r.type === "slides" ? "fa-file-powerpoint" :
    r.type === "notebook" ? "fa-file-lines" :
    "fa-file-contract";